import * as React from 'react'

import getConfig from 'next/config'

import { AuthProvider, Routes, Types as AuthTypes } from '@grandvisionhq/auth'

type AuthConfig = React.ComponentProps<typeof AuthProvider>['settings']

const { publicRuntimeConfig } = getConfig()
const apiUrl = publicRuntimeConfig.grandvision.apiUrl ?? ''
const { auth0Domain, auth0CustomDomain, auth0ClientId } =
  publicRuntimeConfig.grandvision.myAccount ?? {}

const routes: Routes = {
  createAccount: 'create',
  login: 'login',
  logout: 'logout',
  orders: 'orders',
  prescriptions: 'prescriptions',
  signup: 'signup',
  profile: 'profile',
  settings: 'settings',
  appointments: 'appointments',
  resetPassword: 'reset-password',
  linkExpired: 'link-expired',
  setPassword: 'set-password',
  changePassword: 'change-password',
  verify: 'verify',
  unlinkOrder: 'unlink-order',
  wishlist: 'wishlist',
}

const optIns: AuthTypes.OptInItem[] = [
  {
    titleKey: 'account.optIn.marketingEmails',
    value: 'marketingEmails',
    isInSignup: true,
  },
  {
    titleKey: 'account.optIn.marketingPost',
    value: 'directMail',
  },
  {
    titleKey: 'account.optIn.marketingSMS',
    value: 'marketingSMS',
  },
  {
    titleKey: 'account.optIn.marketingPhone',
    value: 'teleMarketing',
  },
]

const supportFeaturesLinks: AuthTypes.SupportFeatureLink[] = [
  {
    label: 'account.menu.appointments',
    url: routes.appointments,
  },
  {
    label: 'account.menu.orders',
    url: routes.orders,
  },
  {
    label: 'account.menu.settings',
    url: routes.settings,
  },
]

export const getAuthConfig = (): AuthConfig => ({
  apiUrl,
  basePath: 'my-account',
  clientId: auth0ClientId,
  customDomain: auth0CustomDomain,
  domain: auth0Domain,
  routes,
  optIns,
  checkoutRoute: '/checkout/expedicao',
  supportFeaturesLinks,
})
